/* ==========================================================================
   VoxTune — Reviews modal
   Opens on VT.emit('reviews:open'). Centralized review source:
     1) window.VoxTuneReviews (array) — populate from a CSV import or a section
        JSON island (data-voxtune-reviews).
     2) Loox — if window.loox / a #looxReviews container exists, it's surfaced.
   Builds its modal on first open (no weight until requested).
   ========================================================================== */
(function (w, d) {
  'use strict';
  var VT = w.VoxTune;
  var root = null, lastFocus = null;

  function collect() {
    var out = (w.VoxTuneReviews && w.VoxTuneReviews.slice) ? w.VoxTuneReviews.slice() : [];
    d.querySelectorAll('script[data-voxtune-reviews]').forEach(function (el) {
      try { var arr = JSON.parse(el.textContent || '[]'); if (Array.isArray(arr)) out = out.concat(arr); } catch (e) {}
    });
    return out;
  }
  function esc(s) { var e = d.createElement('span'); e.textContent = s == null ? '' : String(s); return e.innerHTML; }
  function stars(n) { n = Math.round(n || 5); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }

  function build() {
    if (root) return root;
    root = d.createElement('div');
    root.className = 'vp-reviews-root';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div data-close style="position:fixed;inset:0;z-index:115;background:rgba(6,7,9,.7);backdrop-filter:blur(3px);animation:vpFade .2s both"></div>' +
      '<div role="dialog" aria-modal="true" aria-label="Reviews" style="position:fixed;left:0;right:0;bottom:0;margin:0 auto;z-index:116;width:min(560px,100%);max-height:88vh;display:flex;flex-direction:column;background:#fff;border:1px solid var(--vp-border,#E5E3DE);border-bottom:none;border-radius:24px 24px 0 0;animation:vpSheet .4s cubic-bezier(.2,.7,.2,1) both;overflow:hidden">' +
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid var(--vp-border,#E5E3DE)"><span style="font-family:var(--vp-font-display,sans-serif);font-size:22px;text-transform:uppercase">Reviews</span><button type="button" data-close aria-label="Close" style="width:34px;height:34px;border:1px solid var(--vp-border,#E5E3DE);background:#fff;cursor:pointer">✕</button></div>' +
        '<div class="vp-reviews-body vp-scroll" style="overflow-y:auto;padding:16px 22px"></div>' +
      '</div>';
    d.body.appendChild(root);
    root.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) close(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });
    // Keep Tab focus within the open modal.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || root.hidden) return;
      var f = root.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return root;
  }

  function open() {
    build(); lastFocus = d.activeElement; root.hidden = false; d.body.style.overflow = 'hidden';
    var closeBtn = root.querySelector('button[data-close]'); if (closeBtn) closeBtn.focus();
    var body = root.querySelector('.vp-reviews-body');
    var loox = d.getElementById('looxReviews') || (w.loox && d.querySelector('.loox-reviews'));
    var data = collect();
    if (data.length) {
      body.innerHTML = data.map(function (r) {
        return '<figure style="margin:0 0 14px;border:1px solid var(--vp-border,#E5E3DE);border-radius:10px;padding:14px">' +
          '<div style="color:var(--vp-accent,#FF9A3D);letter-spacing:1px">' + stars(r.rating) + '</div>' +
          '<blockquote style="margin:8px 0 0;font-weight:700;line-height:1.4">' + esc(r.body || r.text || '') + '</blockquote>' +
          '<figcaption class="vp-mono" style="font-size:11px;color:var(--vp-muted,#8A8C93);margin-top:8px">' + esc(r.author || r.name || '') + (r.product ? ' · ' + esc(r.product) : '') + '</figcaption></figure>';
      }).join('');
    } else if (loox) {
      body.innerHTML = '';
      body.appendChild(loox.cloneNode(true));
    } else {
      body.innerHTML = '<div style="text-align:center;padding:30px;color:var(--vp-muted,#8A8C93)">' +
        '<div style="font-size:34px;color:var(--vp-accent,#FF9A3D)">★★★★★</div>' +
        '<p style="margin:10px 0 0">Reviews are loading. Connect Loox or import a CSV to populate this list.</p></div>';
    }
  }
  function close() { if (root) root.hidden = true; d.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }

  if (VT) VT.on('reviews:open', open);
})(window, document);
